<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-stats-overall">
    <!-- <div class='header'> -->
      <!-- <span>Model processing: {{statsTitles[selectedStat]}}</span> -->
      <!-- <span class='over-all-content'>Total sessions (100,000) - Inactive sessions (20,000) = Total Conversations (80,000)</span>
      <span class='filter-label'> </span>
      <el-select
          ref="modelWaterfallFilter"
          v-model="selectedStat"
          collapse-tags
          :style="{'width': selectedStat == 'BotOnlyEscalated' ? '320px' : '215px'}">
        <el-option
          v-for="(statTitle, statName) in statsTitles"
          :key="statName"
          :label="statTitle"
          :value="statName">
        </el-option>
      </el-select> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-analytics-stats-overall',
  props: ['summaryData',],

  data() {
    return {
      module: this,
      selectedStat: "",
      selectedStatTitle: null,
    }
  },

  computed: {
    ...mapGetters(['dataModel']),

    formattedData() {
      if (!this.summaryData || this.summaryData.length == 0) {
        // If summaryData is not ready yet, any property of formattedData will be '-'
        return new Proxy({}, {
          get() {
            return '-';
          }
        });
      }

      // Include the values in the three circles into the data we want to format
      let allData = {
        ...this.summaryData,
        'convsProcessed': this.convsProcessed * this.$store.getters.xnumber,
        'convsUnderstood': this.convsUnderstood * this.$store.getters.xnumber,
        'convsWithReason': this.convsWithReason * this.$store.getters.xnumber,
      };

      // Return the same data with every value formatted using our formatter
      return Object.fromEntries(
        Object.entries(allData).map(
          ([key, value],) => [key, WyUtils.formatterNumber(value)]
        )
      );
    },

    convsProcessed() {
      if (!this.summaryData)
        return null;
      return this.summaryData['totalWereAnalyzed' + this.selectedStat];
    },

    convsUnderstood() {
      if (!this.summaryData)
        return null;
      return this.summaryData['totalUnderstood' + this.selectedStat];
    },

    convsWithReason() {
      if (!this.summaryData)
        return null;
      return this.summaryData['totalValidReasons' + this.selectedStat];
    },

    dropFromProcessedToUnderstood() {
      return WyUtils.formatterNumber(this.convsUnderstood/this.convsProcessed*100-100);
    },

    dropFromUnderstoodToWithReason() {
      return WyUtils.formatterNumber(this.convsWithReason/this.convsUnderstood*100-100);
    },

    boxWidthOfWithReason() {
      return 110;
    },

    boxWidthOfProcessed() {
      let boxWidthsRatio = this.convsProcessed / this.convsWithReason;
      if (!boxWidthsRatio)
        return this.boxWidthOfWithReason;
      return Math.min(boxWidthsRatio, 1.75) * this.boxWidthOfWithReason;
    },

    boxWidthOfUnderstood() {
      let boxWidthsRatio = this.convsUnderstood / this.convsProcessed;
      if (!boxWidthsRatio)
        return this.boxWidthOfWithReason;
      return boxWidthsRatio * this.boxWidthOfProcessed;
    },

    boxWidthMax() {
      // if (!this.summaryData)
      //   return 0;
      // let allStats = Object.keys(this.summaryData)
      //     .filter((el)=>el.startsWith('totalWereAnalyzed'))
      //     .map((el)=>el.slice('totalWereAnalyzed'.length));
      // let max = 0;
      // for (let stat of allStats) {
      //   let boxWidthsRatio = this.summaryData['totalWereAnalyzed'+stat] / this.summaryData['totalValidReasons'+stat];
      //   boxWidthsRatio = Math.min(boxWidthsRatio, 1.75);
      //   max = Math.max(max, boxWidthsRatio * this.boxWidthOfWithReason);
      // }
      // max = max + 16*2; // plus two of 16px padding
      // return Math.max(120, max);
      return 150;
    },

  },

  watch: {
    'selectedStat': function(newValue, oldValue) {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'model_stats_page_filter_changed_in_waterfall_section', 
        data: {'prior_filter': this.statsTitles[oldValue], 'current_filter': this.statsTitles[newValue]}});
    },
  },

  methods: {
    ...mapActions(['applyFilterValue']),

    async handleOpenContactReasons() {
      // Changing the global filters according to selectedStat
      // let filterValue = {
      //   '': ['BotOnlyContained', 'BotOnlyEscalated', 'BOT', 'BotToLC', 'LCOnly', ],
      //   'BotOnly': ['BotOnlyContained', 'BotOnlyEscalated', 'BOT', ],
      //   'BotOnlyContained': ['BotOnlyContained', 'BOT', ],
      //   'BotOnlyEscalated': ['BotOnlyEscalated', 'BOT', ],
      //   'BotToLCOnly': ['BotToLC', ],
      //   'LCOnly': ['LCOnly', ],
      //}[this.selectedStat]; // Mapping stat name to corresponding filter name

      // this.dataModel.filters.sources.value = filterValue;
      // this.dataModel.filters.maxTopics.value = this.dataModel.filters.maxTopics.maxValue;
      // await this.applyFilterValue(this.dataModel.filters.sources);
      // await this.applyFilterValue(this.dataModel.filters.maxTopics);

      this.$router.push({path: '/analytics/contactReasonsPage'});
    },
  },

  created() {
    this.statsTitles = {
      '': 'All conversations',
      'BotOnly': 'VA only',
      'BotOnlyContained': 'VA contained',
      'BotOnlyEscalated': 'Live agent requested but not connected',
      'BotToLCOnly': 'VA engaged with live agent connected',
      'LCOnly': 'Live agent only',
    }
  },

  mounted() {
    this.$root.registerTooltips(this.$el);
    this.$root.$on(`fire-container-main-scroll-events`, () => {
      if(this.$refs.modelWaterfallFilter) {
        this.$refs.modelWaterfallFilter.blur();
      }
    });
  },

  beforeDestroy() {
    this.$root.unregisterTooltips(this.$el);
  }
});
</script>

<style lang="scss">
.wy-analytics-stats-overall {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    .title {
      font-size: 19px;
      font-weight: bold;
    }
    .filter-label {
      margin-left: auto;
      margin-right: 5px;
      font-size: 14px;
    }
    .over-all-content {
      font-size: 16px;
      font-weight: 400;
      color: #6A767C;
    }
    margin: 10px 0;

    .el-select {
      width: fit-content;
    }
    .el-select:hover .el-input__inner {
      border-color: var(--site-font-primary-color);
    }
    .el-input.is-focus .el-input__inner {
      border-color: var(--site-font-primary-color);
    }
    .el-select .el-input__inner:focus {
      border-color: var(--site-font-primary-color);
    }
    // input.el-input__inner {
    //   // border-width: 1px 1px 1px 1px !important;
    //   // border-radius: 10px;
    //   // padding-left: 13px;
    //   // padding-top: 2px;
    //   border-color: transparent;
    //   width: 100%;
    //   font-size: 14px;
    //   font-weight: bold;
    //   color: #002852;
    //   background-color: transparent;
    // }
    // .el-select .el-input .el-select__caret {
    //   background-image: url('../../assets/icons/icon_dropdown_arrow_down.png');
    //   background-repeat: no-repeat;
    //   background-size: 8px 6px;
    //   background-position: center;
    //   vertical-align: middle;
    //   transform: rotateZ(0);
    // }
    // .el-icon-arrow-up:before {
    //   content: " ";
    // }
  }

  .divider {
    position: relative;
    left: -25px;
    width: calc(100% + 94px);
    border: 1px solid rgba(86, 124, 170, 0.26);
    margin: 36px 0 10px 0;
  }

  .flowchart {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 18px 0;
    margin-bottom: 27px; // 27px is the height of the "view all" button - using this margin to make "view all" button protrude downwards

    .flowchart-number {
      font-weight: 900;
      font-size: 32px;
      color: #0B284F;
    }

    .flowchart-title {
      font-weight: 600;
      font-size: 16px;
      color: #567CAA;
    }

    .flowchart-box {
      position: relative;
      min-height: 56px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      grid-gap: 5px;

      z-index: 4;
      width: calc((100% - 480px)/3);
      background-color: rgb(252, 252, 252);
      border: 1px solid rgba(86, 124, 170, 0.26);
      border-radius: 13px;
      padding: 16px 30px;
      transition: all 0.3s ease-in-out;
    }

    .flowchart-arrow {
      position: relative;
      z-index: 5;
      width: 70px;
      height: 90px;
      text-align: center;
      line-height: 90px;

      background-image: url('../../assets/images/analytics/flowchart_arrow.svg');
      background-repeat: no-repeat;
      background-position-y: center;
      background-size: 70px;

      font-weight: bold;
      font-size: 12px;
      color: #567CAA;
    }

    .flowchart-view-all {
      margin: auto 0 auto auto;
      text-align: center;
      .flowchart-view-all-box {
        padding: 20px;
        font-size: 13px;
        width: 115px;
        border-radius: 13px;
        text-align: center;
        background-color: rgba(161, 165, 206, 0.12);
        .flowchart-view-all-title {
          font-weight: 600;
          font-size: 12px;
          color: #567CAA;
        }
        .flowchart-overall-total-topic {
          font-size: 24px;
          font-weight: 600;
          margin: 5px 0px;
        }
      }
      button{
        background-color: transparent;
        color: var(--site-font-primary-color);
        font-weight: 700;
        text-decoration: underline;
        border-radius: 8px;
        padding: 6px 0;
        margin-top: 10px;
        border: none;
        cursor: pointer;
      }
    }

    .box {
      padding: 20px;
      font-size: 13px;
      width: 120px;
      border: 1px solid rgb(53, 70, 94);
      border-radius: 4px;
      margin: auto 0 auto auto;
      text-align: center;
      .number-contact-reason {
        color: rgb(18, 40, 76);
        .total-chat {
          font-weight: 600;
        }
      }
      .view-all {
        background-color: #0B284F;
        color: white;
        border-radius: 8px;
        padding: 6px 10px;
        margin-top: 10px;
        border: none;
        cursor: pointer;
      }
    }
  }
}
</style>